import type { ChatStore } from "../Store";
import FlexoApiConnector from "@/Services/TherapyApi/Flexo";
import BotStageApiToBotStageTransformer from "@/Modules/Transformers/Chat/Bot/BotStageApiToBotStage";
import { danger } from "@/Utils/Debug";

class InitializeBotActionHandler {
  constructor(
    private readonly chatStore: ChatStore,
    private readonly botApiConnector = new FlexoApiConnector(),
    private readonly botStageApiToBotStageTransformer = new BotStageApiToBotStageTransformer()
  ) {}

  public async handle(): Promise<void> {
    try {
      this.chatStore.isStartingAnswer = true;

      const botStageApiResponse = await this.botApiConnector.getCurrentStages();

      const botStage = await this.botStageApiToBotStageTransformer.transform(botStageApiResponse);

      this.chatStore.botStage = botStage;
      this.chatStore.isStartingAnswer = false;
    } catch (e) {
      danger("Error init bot");
    }
  }
}

export default InitializeBotActionHandler;
